__webpack_require__.p = "/bizx-smart/atelier/";